import _ from "lodash";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { Card } from "react-bootstrap";
import DropdownItem from "react-bootstrap/DropdownItem";
import Tab from "react-bootstrap/Tab";
import BootstrapTable from "react-bootstrap/Table";
import { useIntl } from "react-intl";
import * as uuid from "uuid";
import {
    CHART_MODE_CHART,
    CHART_MODE_TABLE,
    COMMENT,
    NUMBER,
    TEXT,
    TOTAL
} from "../../../../../ducks/collapsibleTableChart";
import ObjectUtils from "../../../../../utils/ObjectUtils";
import { QuestionIcon } from "../../../../../utils/QuestionUtils";
import { getObjectFromList, getSubQuestionModifiedId, isTypeRelevant } from "../../../../../utils/TableUtils";
import CollapsibleCardHeader from "../CollapsibleCardHeader";
import HorizontalTable from "../HorizontalTable";
import { formatNumber } from "../NumberFormatUtils";
import TextTable from "../TextTable";
import CSVTypeQuestion from "./CSVTypeQuestion";
import NumberQuestion from "./NumberQuestion";

const DynamicTableQuestion = ({
                                  table,
                                  collapsibleTablesDetails,
                                  csvQuestionDetails,
                                  modalSelectParameters,
                                  renderHeader,
                                  renderChart,
                                  renderPivotBreadcrumb,
                                  handleClickDownloadPivotQuestion,
                                  handleModalOpen,
                                  handlePivotShortcutSubmit,
                                  handleBeginningClick,
                                  handlePercentageClick,
                                  getQuestionPath,
                                  getBreadcrumbPath,
                                  pivotShortcut,
                                  sinceBeginning,
                                  status,
                                  label,
                                  percentage,
                                  optionsArray,
                                  notExpandableArray,
                                  tabActive,
                                  onTabClick,
                                  getActiveTabDynamic
                              }) => {
    let headers = [];
    let contents = [];
    let tableProps = ObjectUtils.findByObjectProp(table.anwser.anwserList, "questionType", "TOTAL");

    const [chartMode, setChartMode] = useState({});
    const intl = useIntl();

    const handleSelectChartMode = (identifier) => {
        let tmp = _.cloneDeep(chartMode);
        tmp[identifier] = CHART_MODE_CHART;
        setChartMode(tmp);
    };

    const handleSelectTableMode = (identifier) => {
        let tmp = _.cloneDeep(chartMode);
        tmp[identifier] = CHART_MODE_TABLE;
        setChartMode(tmp);
    };

    const renderDynamicSubQuestionsTable = (
        column,
        detailsShown,
        subquestionType,
        firstColumnTitle,
        tableId,
        groupByColumnKey
    ) => {
        let selectedYears = label ? [...label] : [];
        return (
            <>
                {subquestionType === NUMBER ? (
                    <NumberQuestion
                        table={column}
                        percentage={percentage[tableId]}
                        detailsShown={detailsShown}
                        firstColumnTitle={firstColumnTitle}
                        tableId={tableId.toString()}
                        renderStats
                    />
                ) : isTypeRelevant(subquestionType, notExpandableArray) ? (
                    <CSVTypeQuestion
                        table={table}
                        subquestion={column.anwserList[0]}
                        optionsArray={optionsArray}
                        subQuestionTitle={column.anwserList[0].title}
                        csvQuestionDetails={csvQuestionDetails}
                        modalSelectParameters={modalSelectParameters}
                        status={status}
                        label={label}
                        percentage={percentage}
                        renderChart={renderChart}
                        renderPivotBreadcrumb={renderPivotBreadcrumb}
                        handleClickDownloadPivotQuestion={handleClickDownloadPivotQuestion}
                        handleModalOpen={handleModalOpen}
                        handlePivotShortcutSubmit={handlePivotShortcutSubmit}
                        handleBeginningClick={handleBeginningClick}
                        handlePercentageClick={handlePercentageClick}
                        getQuestionPath={getQuestionPath}
                        getBreadcrumbPath={getBreadcrumbPath}
                        pivotShortcut={pivotShortcut}
                        sinceBeginning={sinceBeginning}
                    />
                ) : isTypeRelevant(subquestionType, optionsArray) ? (
                    subquestionType === TEXT || subquestionType === COMMENT ? (
                        <TextTable
                            data={column}
                            tableId={`table_${tableId}`}
                            subQuestionDetails={detailsShown}
                            key={uuid.v4()}
                            years={selectedYears}
                            firstColumnTitle={firstColumnTitle}
                        />
                    ) : (
                        <HorizontalTable
                            data={column}
                            percentage={percentage[tableId]}
                            tableId={`table_${tableId}`}
                            subQuestionDetails={detailsShown}
                            key={uuid.v4()}
                            firstColumnTitle={firstColumnTitle}
                            useZAxisValue={groupByColumnKey === "project"}
                        />
                    )
                ) : null}
            </>
        );
    };

    if (tableProps) {
        const subquestionModifiedId = table.questionId;
        headers.push(
            <DropdownItem
                key={subquestionModifiedId}
                eventKey={subquestionModifiedId}
                active={tabActive === subquestionModifiedId}
                onClick={() => {
                    if (tabActive !== subquestionModifiedId) {
                        onTabClick(subquestionModifiedId);
                    }
                }}
            >
                <QuestionIcon type={"number"} className="me-2"/>
                {intl.formatMessage({id: "collapsible.table.question.total"})}
            </DropdownItem>
        );
        let detailsShown = getObjectFromList(collapsibleTablesDetails, table.questionId);
        if (detailsShown) {
            const parameters = modalSelectParameters[table.questionId];
            contents.push(
                <Tab.Pane key={table.questionId} eventKey={table.questionId}>
                    <Card>
                        <Card.Header>
                            <CollapsibleCardHeader
                                data={tableProps}
                                baseQuestionId={table.questionId}
                                baseQuestionTitle={table.questionTitle}
                                shortcutType={pivotShortcut[table.questionId]?.shortcutType}
                                baseColumnType={TOTAL}
                                isSubquestion={true}
                                baseQuestionType={table.questionType}
                                baseQuestionKey={table.questionKey}
                                baseQuestionGroupKey={""}
                                chartMode={chartMode[table.questionId]}
                                handleClickDownloadQuestion={handleClickDownloadPivotQuestion}
                                handleModalOpen={handleModalOpen}
                                handlePivotShortcutSubmit={handlePivotShortcutSubmit}
                                handleSelectChartModeTable={() => handleSelectTableMode(table.questionId)}
                                handleSelectChartModeChart={() => handleSelectChartMode(table.questionId)}
                                onBeginningClick={handleBeginningClick}
                                onPercentageClick={handlePercentageClick}
                                baseQuestionString={getQuestionPath(table.questionTitle)}
                                groupByQuestionString={detailsShown ? getBreadcrumbPath(table.questionId) : ""}
                                percentageOn={percentage}
                                checked={!!sinceBeginning[table.questionId]}
                                status={status}
                                key={uuid.v4()}
                                periodCount={table.periodCount}
                                renderBreadcrumb={!!detailsShown}
                                onRenderBreadcrumb={() => renderPivotBreadcrumb(table.questionId)}
                                columns={headers}
                            />
                        </Card.Header>
                        <Card.Body>
                            <>
                                {!chartMode[table.questionId] ||
                                chartMode[table.questionId] === CHART_MODE_TABLE ? (
                                    <HorizontalTable
                                        data={tableProps}
                                        percentage={percentage[table.questionId]}
                                        tableId={`table_${table.questionId}`}
                                        subQuestionDetails={detailsShown}
                                        key={uuid.v4()}
                                        firstColumnTitle={
                                            pivotShortcut[table.questionId]?.firstColumnTitle
                                                ? pivotShortcut[table.questionId]?.firstColumnTitle
                                                : parameters?.firstColumnTitle
                                        }
                                        useZAxisValue={parameters?.groupByColumnKey === "project"}
                                    />
                                ) : (
                                    renderChart(
                                        tableProps,
                                        detailsShown,
                                        NUMBER,
                                        parameters?.groupByColumnName,
                                        parameters?.groupByColumnKey
                                    )
                                )}
                            </>
                        </Card.Body>
                    </Card>
                </Tab.Pane>
            );
        } else {
            contents.push(
                <Tab.Pane key={uuid.v4()} eventKey={table.questionId}>
                    <Card>
                        <Card.Header>
                            <CollapsibleCardHeader
                                data={tableProps}
                                baseQuestionId={table.questionId}
                                baseQuestionTitle={table.questionTitle}
                                shortcutType={pivotShortcut[table.questionId]?.shortcutType}
                                baseColumnType={TOTAL}
                                isSubquestion={true}
                                baseQuestionType={table.questionType}
                                baseQuestionKey={table.questionKey}
                                baseQuestionGroupKey={""}
                                chartMode={chartMode[table.questionId]}
                                handleClickDownloadQuestion={handleClickDownloadPivotQuestion}
                                handleModalOpen={handleModalOpen}
                                handlePivotShortcutSubmit={handlePivotShortcutSubmit}
                                handleSelectChartModeTable={() => handleSelectTableMode(table.questionId)}
                                handleSelectChartModeChart={() => handleSelectChartMode(table.questionId)}
                                onBeginningClick={handleBeginningClick}
                                onPercentageClick={handlePercentageClick}
                                baseQuestionString={getQuestionPath(table.questionTitle)}
                                groupByQuestionString={detailsShown ? getBreadcrumbPath(table.questionId) : ""}
                                percentageOn={percentage}
                                checked={!!sinceBeginning[table.questionId]}
                                status={status}
                                key={uuid.v4()}
                                periodCount={table.periodCount}
                                columns={headers}
                            />
                        </Card.Header>
                        <Card.Body>
                            <BootstrapTable responsive striped bordered hover className="horizontal"
                                            id={`table_${table.questionId}`}>
                                <thead>
                                <tr>
                                    <th>{intl.formatMessage({id: "collapsible.table.question.number.of.rows"})}</th>
                                    <th>{formatNumber(tableProps?.data?.[0]?.yaxisValue)}</th>
                                </tr>
                                </thead>
                            </BootstrapTable>
                        </Card.Body>
                    </Card>
                </Tab.Pane>
            );
        }
    }

    table.anwser.anwserList.forEach((column, index) => {
        let subquestionType = column.questionType;
        let colId;
        let rowId;
        let colKey;
        let identifier;
        if (column && column.tableIdentifier) {
            colId = column.tableIdentifier.colId;
            rowId = column.tableIdentifier.rowId;
            colKey = column.tableIdentifier.columnKey;
            identifier = colKey ? colKey : (colId ? colId.toString() : "0") + (rowId ? rowId.toString() : "0");
        }

        let subquestionModifiedId = getSubQuestionModifiedId(table.questionId, identifier, rowId, colId);
        let detailsShown = getObjectFromList(collapsibleTablesDetails, subquestionModifiedId);
        const parameters = modalSelectParameters[subquestionModifiedId];

        headers.push(
            subquestionType !== TOTAL && (
                <DropdownItem
                    key={subquestionModifiedId}
                    eventKey={subquestionModifiedId}
                    active={tabActive === subquestionModifiedId}
                    onClick={() => {
                        if (tabActive !== subquestionModifiedId) {
                            onTabClick(subquestionModifiedId);
                        }
                    }}
                >
                    {renderHeader(
                        detailsShown,
                        column.title,
                        subquestionType,
                        subquestionModifiedId,
                        table.questionId,
                        colId,
                        rowId,
                        "dynamic",
                        index
                    )}
                </DropdownItem>
            )
        );
        const headTitle = <span><QuestionIcon type={subquestionType} /> {column.title}</span>;
        contents.push(
            subquestionType !== TOTAL && (
                <Tab.Pane key={subquestionModifiedId} eventKey={subquestionModifiedId}>
                    <Card>
                        <Card.Header>
                            <CollapsibleCardHeader
                                data={column}
                                baseQuestionId={table.questionId}
                                baseQuestionColId={colId ? colId : 0}
                                baseQuestionRowId={rowId ? rowId : 0}
                                baseQuestionTitle={column.title}
                                shortcutType={pivotShortcut[subquestionModifiedId]?.shortcutType}
                                baseColumnType={subquestionType}
                                isSubquestion={true}
                                baseQuestionType={table.questionType}
                                baseQuestionKey={table.questionKey}
                                baseQuestionRowKey={column?.tableIdentifier?.rowKey}
                                baseQuestionColumnKey={column?.tableIdentifier?.columnKey}
                                baseQuestionGroupKey={""}
                                chartMode={chartMode[subquestionModifiedId]}
                                handleClickDownloadQuestion={handleClickDownloadPivotQuestion}
                                handleModalOpen={handleModalOpen}
                                handlePivotShortcutSubmit={handlePivotShortcutSubmit}
                                handleSelectChartModeTable={() => handleSelectTableMode(subquestionModifiedId)}
                                handleSelectChartModeChart={() => handleSelectChartMode(subquestionModifiedId)}
                                onBeginningClick={handleBeginningClick}
                                onPercentageClick={handlePercentageClick}
                                baseQuestionString={getQuestionPath(table.questionTitle, column.title)}
                                groupByQuestionString={detailsShown ? getBreadcrumbPath(subquestionModifiedId) : ""}
                                percentageOn={percentage}
                                baseQuestionIdentifier={identifier}
                                checked={!!sinceBeginning[table.questionId]}
                                status={status}
                                key={uuid.v4()}
                                periodCount={table.periodCount}
                                renderBreadcrumb={!!detailsShown}
                                onRenderBreadcrumb={() => renderPivotBreadcrumb(subquestionModifiedId)}
                                columns={headers}
                            />
                        </Card.Header>
                        <Card.Body>
                            {!chartMode[subquestionModifiedId] || chartMode[subquestionModifiedId] === CHART_MODE_TABLE
                                ? renderDynamicSubQuestionsTable(
                                    column,
                                    detailsShown,
                                    subquestionType,
                                    detailsShown
                                        ? pivotShortcut[subquestionModifiedId]?.pivotShortcut
                                            ? pivotShortcut[subquestionModifiedId].pivotShortcut
                                            : headTitle
                                        : headTitle,
                                    subquestionModifiedId,
                                    parameters?.groupByColumnKey
                                )
                                : renderChart(
                                    column,
                                    detailsShown,
                                    subquestionType,
                                    parameters?.groupByColumnName,
                                    parameters?.groupByColumnKey
                                )}
                        </Card.Body>
                    </Card>
                </Tab.Pane>
            )
        );
    });

    return (
        <Tab.Container activeKey={getActiveTabDynamic(table)}>
            <Tab.Content>{contents.map((elem) => elem)}</Tab.Content>
        </Tab.Container>
    );
};

DynamicTableQuestion.propTypes = {
    table: PropTypes.object,
    percentage: PropTypes.object,
    intl: PropTypes.object,
    detailsShown: PropTypes.object,
    staticTableCols: PropTypes.bool,
    firstColumnTitle: PropTypes.string,
    tableId: PropTypes.string,
    renderSimpleTable: PropTypes.bool,
    renderHeader: PropTypes.func,
    renderStats: PropTypes.bool,
    collapsibleTablesDetails: PropTypes.array,
    csvQuestionDetails: PropTypes.array,
    modalSelectParameters: PropTypes.object,
    status: PropTypes.string,
    label: PropTypes.array,
    optionsArray: PropTypes.array,
    renderChart: PropTypes.func,
    renderPivotBreadcrumb: PropTypes.func,
    handleClickDownloadPivotQuestion: PropTypes.func,
    handleModalOpen: PropTypes.func,
    handlePivotShortcutSubmit: PropTypes.func,
    handleBeginningClick: PropTypes.func,
    handlePercentageClick: PropTypes.func,
    getQuestionPath: PropTypes.func,
    getBreadcrumbPath: PropTypes.func,
    pivotShortcut: PropTypes.object,
    sinceBeginning: PropTypes.object,
    notExpandableArray: PropTypes.array,
    getActiveTabDynamic: PropTypes.func
};

export default DynamicTableQuestion;
